
  import AeqIDValidatorBase from "./AeqIDValidatorBase.vue"

  // Step constants
  const STEP_SELECT_COUNTRY = 2
  const STEP_PREPARE_DOCUMENT = 3
  const STEP_VALIDATE_FRONT = 5

  export default {
    name: `AeqIDValidatorPermit`,
    extends: AeqIDValidatorBase,
    data() {
      return {
        type: `permit`,
        document: {
          type: `id`,
          withMrz: null,
          withMrzCropped: null,
          withoutMrz: null,
          withoutMrzCropped: null
        },
        step: STEP_PREPARE_DOCUMENT,
        wantedDocType: `work_permit_document`
      }
    },
    methods: {
      getDocName(side) {
        if (side === "front") {
          return `Permit-Front.png`
        }
        return `Permit-Back.png`
      },
      shouldShowPrevButton() {
        if (this.step <= STEP_SELECT_COUNTRY || this.step === STEP_VALIDATE_FRONT) {
          return false
        }
        return true
      },
      getDocType() {
        return this.type
      },
      resetSteps() {
        this.step = STEP_PREPARE_DOCUMENT
      }
    }
  }
